module.exports = " ";


//////////////////
// WEBPACK FOOTER
// ./src/app/authorization/login/index.html
// module id = 379
// module chunks = 0